import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Text from 'v3/components/Text';
import TextArea from 'v3/components/TextArea';

export default function ObservationInput({
  label = '',
  value = '',
  onChange = () => {},
  error = '',
  disabled = false,
  id,
}) {
  return (
    <Row className="mt-2">
      <Col xs={12} md={12}>
        <Text type="medium" weight={500}>
          {label}
        </Text>
        <TextArea
          value={value}
          onChange={onChange}
          error={error}
          disabled={disabled}
          id={id}
          containerStyle={{ width: '100%' }}
          containerInsideStyle={{ width: '100%' }}
          style={{ width: '100%' }}
        />
      </Col>
    </Row>
  );
}
